import { baseApi } from 'core/api/base'
import { generatePath } from 'react-router'
import { IKpiRequest, IKpiResponse } from 'core/interfaces/Kpi'

const KPI_ENDPOINT = '/kpi'
const KPI_GLOBAL_ENDPOINT = '/kpi-global'
const kpiApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getKpis: builder.mutation<Record<string, IKpiResponse[]>, IKpiRequest>({
      query: (body) => ({
        url: generatePath(KPI_ENDPOINT),
        method: 'POST',
        body: body,
      }),
    }),
    getGlobalKpis: builder.mutation<IKpiResponse[], IKpiRequest>({
      query: (body) => ({
        url: generatePath(KPI_GLOBAL_ENDPOINT),
        method: 'POST',
        body: body,
      }),
    }),
  }),
})
export const { useGetKpisMutation, useGetGlobalKpisMutation } = kpiApi
export { kpiApi }
